import React, { useEffect, useState, useRef } from "react";
import { Row, Col, Card, Icon } from "antd";
// Styles
import { Wrapper, H4, H5 } from "./styles";

import colors from "../../theme/colors";

import { Line, Chart } from 'react-chartjs-2';

import 'chartjs-plugin-annotation'

// Hooks
import useHistorical from '../../hooks/useHistorical';


//import multilanguage library
import { useTranslation } from 'react-i18next'

const INITIAL_SUMMARY = {
    summary: 0,
    furnace: {temp: 0, time: 0},
    quenching: {temp: 0, agit: 0},
    tempered: {temp: 0, time: 0}
}

const INITIAL_CHARTS = {
    labelsFurnace: [],
    data_furnace_temp: [],
  
    labelsQuenching: [],
    data_quenching_temp: [],
    data_quenching_agit: [],
    colors_quenching_agit: [],

    labelsTempered: [],
    data_tempered_temp: []
  }

const chartColors = {
  time: 'rgba(54, 162, 235, 0.3)',
  temp: 'rgba(255, 159, 64, 0.4)',
  error: 'rgba(255, 99, 132, 0.5)'
}

const RenderPieces = ({design}) => {
    const [summary, setSummary] = useState(INITIAL_SUMMARY);
    const [chartValues, setChartsValue] = useState(INITIAL_CHARTS);

    const { pieceSelected, temporalLine } = useHistorical();

    //Chart images reference to download
    const image_down_furnace_chart = useRef(null);
    const image_down_quenching_chart = useRef(null);
    const image_down_tempered_chart = useRef(null);

     //To translate text
     const { t } = useTranslation();

  useEffect(() => {
    if (pieceSelected) {
      let data = returnData(pieceSelected);
      setSummary(data.summary);
      setChartsValue(data.charts);
    }
  }, [pieceSelected]);

  useEffect(() => {
    Chart.pluginService.register({
      afterDraw: function (chart, easing) {
        //if chart il loaded 100%
        if (easing === 1) {
          //get url of canvas
          let canvas = chart.canvas;
          canvas.style.backgroundColor = "white"; //background white to good visualize
          let url_base64jp = canvas.toDataURL("image/jpg", 1.0);
          
          if (canvas.id === "3" && image_down_furnace_chart.current) image_down_furnace_chart.current.href = url_base64jp
          else if (canvas.id === "4" && image_down_quenching_chart.current) image_down_quenching_chart.current.href = url_base64jp
          else if (canvas.id === "5" && image_down_tempered_chart.current) image_down_tempered_chart.current.href = url_base64jp
        }
      }, 
      
    });
  }, [design]);


  const returnData = piece => {

    //Get indexes
    let startIndexFurnace = temporalLine.findIndex(el => el.time > piece.furnace.start - 350 && el.time < piece.furnace.start + 350);
    let endIndexFurnace = temporalLine.findIndex(el => el.time > piece.furnace.end - 350 && el.time < piece.furnace.end + 350);

    let endIndexQuenching = temporalLine.findIndex(el => el.time > piece.quenching.end - 350 && el.time < piece.quenching.end + 350);

    let startIndexTempered = temporalLine.findIndex(el => el.time > piece.tempered.start - 350 && el.time < piece.tempered.start + 350);
    let endIndexTempered = temporalLine.findIndex(el => el.time > piece.tempered.end - 350 && el.time < piece.tempered.end + 350);

    let arrayFurnacePiece = temporalLine.slice(startIndexFurnace,endIndexFurnace);
    let arrayQuenchingPiece = temporalLine.slice(endIndexFurnace,endIndexQuenching);
    let arrayTemperedPiece = temporalLine.slice(startIndexTempered,endIndexTempered);


    let charts = {
        labelsFurnace: [],
        data_furnace_temp: [],
      
        labelsQuenching: [],
        data_quenching_temp: [],
        data_quenching_agit: [],
        colors_quenching_agit: [],
        radius_quenching_agit: [],
    
        labelsTempered: [],
        data_tempered_temp: []
    }

    //Charge furnace data
    charts.labelsFurnace = arrayFurnacePiece.map(function(key) {
        return new Date(key.time*1000);
    });
    charts.data_furnace_temp = arrayFurnacePiece.map(function(key) {
        return key.furnaceTemp;
    });

    //Charge quenching data
    charts.labelsQuenching = arrayQuenchingPiece.map(function(key) {
        return new Date(key.time*1000);
    });
    charts.data_quenching_temp = arrayQuenchingPiece.map(function(key) {
        return key.quenchingTemp;
    });
    charts.data_quenching_agit = arrayQuenchingPiece.map(function(key) {
        return key.quenchingAgit;
    });
    charts.colors_quenching_agit = arrayQuenchingPiece.map(function(key) {
        return (design && key.quenchingAgit !== design.quenching.agitation_level) ? chartColors.error : chartColors.time ;
    });
    charts.radius_quenching_agit = arrayQuenchingPiece.map(function(key) {
        return (design && key.quenchingAgit !== design.quenching.agitation_level) ? 3 : 1 ;
    });

    //Charge furnace data
    charts.labelsTempered = arrayTemperedPiece.map(function(key) {
        return new Date(key.time*1000);
    });
    charts.data_tempered_temp = arrayTemperedPiece.map(function(key) {
        return key.temperedTemp;
    });    

    return { 
        summary: {
            summary: piece.totalState,
            furnace: {temp: piece.furnace.stateTemp, time: piece.furnace.stateTime},
            quenching: {temp: piece.quenching.stateTemp, agit: piece.quenching.stateAgit},
            tempered: {temp: piece.tempered.stateTemp, time: piece.tempered.stateTime}
        },
        charts
    }
  }

    const RenderProgressQuad = ({title, label1, value1, label2, value2}) => {
        return (
            <Col xl={6} lg={6} md={6}  style={{textAlign: "center", paddingTop: 0}}>
                <Card size="small">
                    <H4>{title}</H4>
                    <H5 style={{ marginTop: "1px" }}>{(value1 ? <Icon type="check" style={{color: colors.success}} /> : <Icon type="close" style={{color: colors.danger}} />)} {label1}</H5>
                    <H5>{(value2 ? <Icon type="check" style={{color: colors.success}} /> : <Icon type="close" style={{color: colors.danger}} />)} {label2}</H5>
                </Card>
            </Col>
        );
    }

    const RenderCardExtra = (keyImage, imageRef) => {
        return [
          <a key={keyImage} src="image.png" ref={imageRef} href="" download><Icon type="download" /></a>
        ];
      }

    const RenderChartPieceFurnace = ({keyCard, keyChart, title, RenderCardExtra, arrayDataString, arrayLabelsString, labelY, labelData, tempMin, limitTime }) => {
        return (
          <Card key={keyCard} size="small" title={title} extra={RenderCardExtra}>
              <Line
                id={keyChart}
                key={keyChart}
                width={100}
                height={30}
                data={{
                    datasets: [{
                        data: chartValues[arrayDataString],
                        label: labelY,
                        backgroundColor: chartColors.temp,
                        borderColor: chartColors.temp,
                        // This binds the dataset to the left y axis
                        yAxisID: 'left-y-axis',
                        fill: false,
                    }],
                    labels: chartValues[arrayLabelsString]
                }}
                options={{
                    animation: false,
                    scales: {
                        xAxes: [{
                            id: 'x-axis',
                            scaleLabel: {
                                display: true,
                                labelString: t('historical.labels.date')
                            },
                            ticks: {
                                fontSize: 8
                            },
                            type: 'time',
                        }],
                        yAxes: [{
                            id: 'left-y-axis',
                            type: 'linear',
                            position: 'left',
                            ticks: {
                            min: Math.min(...chartValues[arrayDataString])-10,
                            max: Math.max(...chartValues[arrayDataString])+10,
                            stepSize: 10,
                            },
                            gridLines: {
                                //display: false
                            },
                            scaleLabel: {
                                display: true,
                                labelString: labelData,
                            },                             
                        }]
                    },
                    legend: {
                        labels: {
                            fontSize: 10,
                            usePointStyle: true,
                        }
                    },
                    annotation: {
                        annotations: [{
                            drawTime: "beforeDatasetsDraw",
                            type: "box",
                            xScaleID: "x-axis",
                            yScaleID: "left-y-axis",
                            xMin: chartValues[arrayLabelsString][0],
                            xMax: chartValues[arrayLabelsString][chartValues[arrayLabelsString].length-1],
                            yMin: tempMin,
                            yMax: 2000,
                            backgroundColor: "rgba(30, 101, 15, 0.2)",
                        },
                        {
                            type: 'line',
                            // optional drawTime to control layering, overrides global drawTime setting
                            drawTime: 'afterDatasetsDraw',
                            // optional annotation ID (must be unique)
                            id: 'a-line-1',
                            // set to 'vertical' to draw a vertical line
                            mode: 'vertical',
                            // ID of the scale to bind onto
                            scaleID: 'x-axis',
                            // Data value to draw the line at
                            value: limitTime && new Date(limitTime*1000),
                            // Optional value at which the line draw should end
                            //endValue: 26,
                            // Line color
                            borderColor: 'red',
                            // Line width
                            borderWidth: 2,
                            // Line dash
                            // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/setLineDash
                            borderDash: [2, 2],
                            // Line Dash Offset
                            // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/lineDashOffset
                            borderDashOffset: 5,
                            label: {
                                // Background color of label, default below
                                backgroundColor: 'rgba(0,0,0,0.8)',
                                // Font family of text, inherits from global
                                fontFamily: "sans-serif",
                                // Font size of text, inherits from global
                                fontSize: 12,
                                // Font style of text, default below
                                fontStyle: "bold",
                                // Font color of text, default below
                                fontColor: "#fff",
                                // Padding of label to add left/right, default below
                                xPadding: 6,
                                // Padding of label to add top/bottom, default below
                                yPadding: 6,
                                // Radius of label rectangle, default below
                                cornerRadius: 6,
                                // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
                                position: "center",
                                // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
                                // For horizontal lines positioned left or right, negative values move
                                // the label toward the edge, and positive values toward the center.
                                xAdjust: 0,
                                // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
                                // For vertical lines positioned top or bottom, negative values move
                                // the label toward the edge, and positive values toward the center.
                                yAdjust: 0,
                                // Whether the label is enabled and should be displayed
                                enabled: false,
                                // Text to display in label - default is null
                                content: "Test label"
                            },
                        }]
                    }
                    
                }}
                // options={{ maintainAspectRatio: false }}
                />
          </Card>
        )
      }


  return (
    <Wrapper>
        <Row style={{ margin: 0 }} gutter={[16, 16]}>
            <Col xl={6} lg={6} md={6}  style={{textAlign: "center", paddingTop: 0}}>
                <Card size="small">
                    <H4>{t('headers.historical.piece_resume')}</H4>
                    <p style={{ margin: 0, marginTop: "19px", marginBottom: "18px" }}>{(summary.summary ? <Icon type="check" style={{color: colors.success, fontSize: 30}} /> : <Icon type="close" style={{color: colors.danger, fontSize: 30}} />)}</p>
                </Card>
            </Col>
            <RenderProgressQuad title={t('phase.furnace')} label1={t('labels.temperature')} value1={summary.furnace.temp} label2={t('labels.time')} value2={summary.furnace.time} />
            <RenderProgressQuad title={t('phase.quenching')} label1={t('labels.temperature')} value1={summary.quenching.temp} label2={t('labels.agitation')} value2={summary.quenching.agit} />
            <RenderProgressQuad title={t('phase.tempered')} label1={t('labels.temperature')} value1={summary.tempered.temp} label2={t('labels.time')} value2={summary.tempered.time} />
        </Row>
        <Row style={{ margin: 0 }} gutter={[16, 16]}>
            <Col xl={24} lg={24} md={24} >
                <RenderChartPieceFurnace 
                  keyCard="furnace_card_piece"
                  keyChart={3}
                  title={t('phase.furnace')}
                  RenderCardExtra={RenderCardExtra("image_furnace_card_piece", image_down_furnace_chart)}
                  arrayDataString="data_furnace_temp"
                  arrayLabelsString="labelsFurnace"
                  labelY={t('historical.legend.temperature')}
                  labelData={t('historical.legend.temperature')}
                  tempMin={design && design.furnace.temperature}
                  limitTime={design && pieceSelected && (pieceSelected.furnace.start+design.recommendation.furnace_time)}
                />
            </Col>
        </Row>
        <Row style={{ margin: 0 }} gutter={[16, 16]}>
            <Col xl={24} lg={24} md={24} >
                {/*<RenderChartPieceFurnace 
                  keyCard="quenching_card_piece"
                  keyChart={4}
                  title={t('phase.quenching')}
                  RenderCardExtra={RenderCardExtra("image_quenching_card_piece", image_down_quenching_chart)}
                />*/}
                <Card key="quenching_card_piece" size="small" title={t('phase.quenching')} extra={RenderCardExtra("image_quenching_card_piece", image_down_quenching_chart)}>
                    <Line
                        id={4}
                        key={4}
                        width={100}
                        height={30}
                        data={{
                            datasets: [{
                                data: chartValues.data_quenching_temp,
                                label: t('historical.legend.temperature_quenching'),
                                backgroundColor: chartColors.temp,
                                borderColor: chartColors.temp,
                                // This binds the dataset to the left y axis
                                yAxisID: 'left-y-axis',
                                fill: false,
                            },
                            {
                                data: chartValues.data_quenching_agit,
                                label: t('historical.legend.agitation_level'),
                                backgroundColor: chartValues.colors_quenching_agit,
                                borderColor: chartValues.colors_quenching_agit,
                                // This binds the dataset to the left y axis
                                yAxisID: 'right-y-axis',
                                fill: false,
                                pointRadius: chartValues.radius_quenching_agit
                            }],
                            labels: chartValues.labelsQuenching
                        }}
                        options={{
                            animation: false,
                            scales: {
                                xAxes: [{
                                    id: 'x-axis',
                                    scaleLabel: {
                                        display: true,
                                        labelString: t('historical.labels.date')
                                    },
                                    ticks: {
                                        fontSize: 8
                                    },
                                    type: 'time',
                                }],
                                yAxes: [{
                                            id: 'left-y-axis',
                                            type: 'linear',
                                            position: 'left',
                                            ticks: {
                                            min: Math.min(...chartValues.data_quenching_temp)-10,
                                            max: Math.max(...chartValues.data_quenching_temp)+10,
                                            stepSize: 10,
                                            },
                                            gridLines: {
                                                //display: false
                                            },
                                            scaleLabel: {
                                                display: true,
                                                labelString: t('historical.legend.temperature'),
                                            },                             
                                        },{
                                            id: 'right-y-axis',
                                            type: 'linear',
                                            position: 'right',
                                            ticks: {
                                            min: 0,
                                            max: 4,
                                            stepSize: 1,
                                            },
                                            gridLines: {
                                                //display: false
                                            },
                                            scaleLabel: {
                                                display: true,
                                                labelString: t('historical.legend.agitation_level'),
                                            },                             
                                        }
                                    ]
                            },
                            legend: {
                                labels: {
                                    fontSize: 10,
                                    usePointStyle: true,
                                }
                            },
                            annotation: {
                                annotations: [{
                                    drawTime: "beforeDatasetsDraw",
                                    type: "box",
                                    xScaleID: "x-axis",
                                    yScaleID: "left-y-axis",
                                    xMin: chartValues.labelsQuenching[0],
                                    xMax: chartValues.labelsQuenching[chartValues.labelsQuenching.length-1],
                                    yMin: 0,
                                    yMax: design && design.quenching.bath_temperature,
                                    backgroundColor: "rgba(30, 101, 15, 0.2)",
                                },
                                {
                                    type: 'line',
                                    // optional drawTime to control layering, overrides global drawTime setting
                                    drawTime: 'afterDatasetsDraw',
                                    // optional annotation ID (must be unique)
                                    id: 'a-line-6',
                                    // set to 'vertical' to draw a vertical line
                                    mode: 'horizontal',
                                    // ID of the scale to bind onto
                                    scaleID: 'right-y-axis',
                                    // Data value to draw the line at
                                    value: design && design.quenching.agitation_level,
                                    // Optional value at which the line draw should end
                                    //endValue: 26,
                                    // Line color
                                    borderColor: 'grey',
                                    // Line width
                                    borderWidth: 2,
                                    // Line dash
                                    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/setLineDash
                                    borderDash: [2, 2],
                                    // Line Dash Offset
                                    // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/lineDashOffset
                                    borderDashOffset: 5,
                                    label: {
                                        // Background color of label, default below
                                        backgroundColor: 'rgba(0,0,0,0.8)',
                                        // Font family of text, inherits from global
                                        fontFamily: "sans-serif",
                                        // Font size of text, inherits from global
                                        fontSize: 12,
                                        // Font style of text, default below
                                        fontStyle: "bold",
                                        // Font color of text, default below
                                        fontColor: "#fff",
                                        // Padding of label to add left/right, default below
                                        xPadding: 6,
                                        // Padding of label to add top/bottom, default below
                                        yPadding: 6,
                                        // Radius of label rectangle, default below
                                        cornerRadius: 6,
                                        // Anchor position of label on line, can be one of: top, bottom, left, right, center. Default below.
                                        position: "center",
                                        // Adjustment along x-axis (left-right) of label relative to above number (can be negative)
                                        // For horizontal lines positioned left or right, negative values move
                                        // the label toward the edge, and positive values toward the center.
                                        xAdjust: 0,
                                        // Adjustment along y-axis (top-bottom) of label relative to above number (can be negative)
                                        // For vertical lines positioned top or bottom, negative values move
                                        // the label toward the edge, and positive values toward the center.
                                        yAdjust: 0,
                                        // Whether the label is enabled and should be displayed
                                        enabled: false,
                                        // Text to display in label - default is null
                                        content: "Test label"
                                    },
                                }]
                            }
                            
                        }}
                        // options={{ maintainAspectRatio: false }}
                        />
                </Card>
            </Col>
        </Row>
        <Row style={{ margin: 0 }} gutter={[16, 16]}>
            <Col xl={24} lg={24} md={24} >
                <RenderChartPieceFurnace 
                  keyCard="tempered_card_piece"
                  keyChart={5}
                  title={t('phase.tempered')}
                  RenderCardExtra={RenderCardExtra("image_tempered_card_piece", image_down_tempered_chart)}
                  arrayDataString="data_tempered_temp"
                  arrayLabelsString="labelsTempered"
                  labelY={t('historical.legend.temperature')}
                  labelData={t('historical.legend.temperature')}
                  tempMin={design && design.tempered.temperature}
                  limitTime={design && pieceSelected && (pieceSelected.tempered.start+design.recommendation.tempered_time)}
                />
            </Col>
        </Row>
    </Wrapper>
  );
};
export default RenderPieces;
